import React, { Component } from "react";
import "fixed-data-table-2/dist/fixed-data-table.css";
import {
  AssessmentData,
  ColorCriteria,
  EvidenceColumn,
  EvidenceColumnGroup,
  EvidencePeriodData,
  EvidenceType,
  Measurement,
  MeasurementType,
  PossibleValue,
  Student,
  StudentEntry,
  StudentRow,
} from "../../../../../store/onboarding/types";
import { DataSortState } from "../../../../../store/dataSort/types";

import ViewBenchmarksModal from "./color-criteria-modal/ViewBenchmarksModal";
import { ValueType } from "react-select/src/types";
import { toastr } from "react-redux-toastr";
import { Cell, Column, ColumnGroup, Table } from "fixed-data-table-2";
import AddStudentsHeaderCell from "./student-data-table/cells/AddStudentsHeaderCell";
import AssessmentHeaderCell from "./student-data-table/cells/AssessmentHeaderCell";
import MeasurementHeaderCell from "./student-data-table/cells/MeasurementHeaderCell";
import DataStudentEntryCell from "./student-data-table/cells/DataStudentEntryCell";
import StudentHeaderCell from "./student-data-table/cells/StudentHeaderCell";
import CheckStudentsHeaderCell from "./student-data-table/cells/CheckStudentsHeaderCell";
import LoadingIndicator from "../../LoadingIndicator";
import SkillsFocusModal from "../../../reading-interventions/intervention-tools/groups-tab/modals/SkillsFocusModal";
import StudentCell from "./student-data-table/cells/StudentCell";
import { Grade } from "../../../../../store/groups/types";
import { getUnknownStudentsLength } from "../../../../../utils/StudentMapUtils";
import EmptyStudentsRows from "./EmptyStudentsRows";

import TeacherInviteIndividuallyModal from "../TeacherInviteIndividuallyModal";
import { getFullName } from "../../../../../utils/NamesUtils";
import DataLoadingCell from "./student-data-table/cells/DataLoadingCell";
import RemoveEvidenceConfirmModal from "./student-data-table/RemoveEvidenceConfirmModal";
import { LocalStorageKeys } from "../../../../../utils/LocalStorageUtils";
import { getStudentGradeFromEcg } from "./student-data-table/Helpers";
import CheckTeacherClassHeaderCell from "./student-data-table/cells/CheckTeacherClassHeaderCell";
import { Overlay, Popover } from "react-bootstrap";
import StudentClassesTab from "./student-data-table/edit-student-dropdown/StudentClassesTab";
import { UserAssignmentRole, UserInfo } from "../../../../../store/auth/types";
import BehaviorScreenerModal from "../../../reading-interventions/intervention-tools/groups-tab/modals/BehaviorScreenerModal";
import _ from "lodash";
import {
  DisplayedColumn,
  StudentRowEditing,
  EvidenceColumnGroupEditing,
  Props,
  Sorting,
  State,
  gradeLevels,
  anotherOrderArray,
  META_GROUP_TYPE_NEEDS,
  ColumnNames,
} from "./evidence-table/Types";
import { getSortFunction, calculateRangeFromCriteria } from "./evidence-table/Helpers";
import { renderStudentGroupIconColumn, renderStudentCheckColumn } from "./evidence-table/RenderHelpers";
import { connectEvidenceTable } from "./evidence-table/Connect";
import * as dataHelpers from "./evidence-table/DataHelpers";

// Re-exported for backward compatibility - other files import these types
// directly from "./EvidenceTable" (e.g. DataStudentEntryCell.tsx).
export { ColumnNames };

export type { StudentRowEditing, Sorting };
export { gradeLevels, anotherOrderArray, META_GROUP_TYPE_NEEDS };



class EvidenceTable extends Component<Props, State> {

  teacherClassModalRef: React.RefObject<HTMLInputElement>; 

  constructor(props: Props) {
    super(props);
    this.teacherClassModalRef = React.createRef();
  }


  defHeight = {
    groupHeaderHeight: 60,
    dataRowHeight: 65,
    headerHeight: 40,
  };

  defMinHeight = {
    dataRowHeight: 45,
    groupHeaderHeight: 60,
    headerHeight: 35,
  };

  state: Readonly<State> = {
    ...this.defHeight,
    scrollToRow: undefined,
    sorting: {
      column: undefined,
      measurement: undefined,
      direction: "asc",
      sortingCount: 0,
      evidenceType: 0
    },
    studentEditingRows: [],
    displayedColumns: JSON.parse(
      localStorage.getItem(LocalStorageKeys.DisplayedColumns) || "[]"
    ),
    selectedStudents: [],
    showDropDown: false,
    isDistrictOwner: false,
    columnWidths: JSON.parse(
      localStorage.getItem(LocalStorageKeys.ColumnWidths) || "{}"
    ),
  };

  elementRef?: HTMLDivElement;
  shadowImageRef?: HTMLDivElement;
  lowestGrade?: number;

  refCallback = (element: HTMLDivElement) => {
    if (element) {
      this.elementRef = element;
      this.calculateTableSize();
    }
  };

  getTableContainerWidth = () => {
    if (!this.props.interventionGroup) {
      const padding = this.props.showTopBar ? 0 : 20;
      return (
        (document.getElementById("user-dashboard")?.clientWidth ?? 0) -
        (document.getElementById("user-dashboard-sidebar")?.clientWidth ?? 0) -
        padding
      );
    }

    //todo maybe remove; need to check RI version

    return (
      (this.elementRef?.parentElement?.clientWidth ??
        this.elementRef?.parentElement?.parentElement?.parentElement
          ?.clientWidth) ||
      0
    );
  };

  getTableContainerHeight = () => {
    const viewPortHeight = document.documentElement.clientHeight;
    let topArea = 0;
    const elements = document.getElementsByClassName("onboardingContainer");
    if (elements.length) {
      topArea =
        document
          .getElementsByClassName("dataTableContainer")?.[0]
          ?.getBoundingClientRect().top ??
        elements[0].getBoundingClientRect().bottom;
    }  

    let margins = 20;
    let filtersHeight = 
        document
          .getElementById("evidence-table-filter-row")
          ?.getBoundingClientRect().height ?? 0;

    return viewPortHeight - topArea - margins - filtersHeight;
  };

  calculateMinimumGrade = (students: Array<StudentRow>) => {
    this.lowestGrade = undefined;
    students?.forEach(s => {
      if (this.props.evidencePeriodData) {
        let grade = getStudentGradeFromEcg(
          this.props.evidencePeriodData.evidence_column_groups,
          s.student.id!
        );
        if (grade) {
          let gradeIndex = gradeLevels.indexOf(grade)
          if (gradeIndex != -1 && (this.lowestGrade == undefined || this.lowestGrade > gradeIndex)) this.lowestGrade = gradeIndex
        }

      }
    })
  }

  calculateTableSize = () => {
    if (this.elementRef) {
      this.setState((prevState) => ({
        ...prevState,
        tableWidth: this.getTableContainerWidth(),
        tableHeight: Math.min(
          this.getTableContainerHeight(),
          (this.props.minimal ? 110 : 120) +
          prevState.dataRowHeight *
          (this.state.evidencePeriodData
            ? this.state.evidencePeriodData?.student_rows?.length
            : 0)
        ),
        ...((window.innerWidth <= 1200 ||
            this.props.isCompressedViewOfDataTable ||
            this.props.minimal)
          ? this.defMinHeight
          : this.defHeight),
      }));
    }
  };

  checkShowLoadKeyModal = () => {
    if (this.state.evidencePeriodData) {
      const length = getUnknownStudentsLength(this.state.evidencePeriodData);
      const flag = localStorage.getItem("showLoadKeyModal");
      if (length !== 0 && !flag) {
        this.props.openLoadKeyModal();
        localStorage.setItem("showLoadKeyModal", "1");
      }
    }
  };

  callbackFunction = () => {
    this.checkShowLoadKeyModal();
    this.calculateTableSize();
  };

  componentDidMount() {
    if (this.props.evidencePeriodData) {
      this.updateStudentData(true, false);
    }

    if(!this.props.schools.length && !this.props.isLoading.getSchoolsList) {
      this.props.getSchools();
    }

    if(!this.props.raceInfo?.races.length) {
      if(this.props.currentDataPeriod){
        this.props.getRaceInfo(this.props.currentDataPeriod.id)
      }
    }

    if ((window.screen.width <= 1200 ||
        this.props.isCompressedViewOfDataTable ||
        this.props.minimal)
    ) {
      this.setState({
        ...this.defMinHeight,
      });
    }

    this.setState(
      (prevState) => ({
        ...prevState,
        displayedColumns: JSON.parse(
          localStorage.getItem(LocalStorageKeys.DisplayedColumns) || "[]"
        ),
      }), () => this.updateStudentData(false, false, false));

    window.addEventListener("resize", this.calculateTableSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.calculateTableSize);
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    if (prevProps.isCompressedViewOfDataTable !==
      this.props.isCompressedViewOfDataTable) {
        this.setState({
          ...(this.props.isCompressedViewOfDataTable
            ? this.defMinHeight
            : this.defHeight),
        });
    }

    if ( 
      (prevProps.isLoading.setValueOfDSEtoDataPeriod &&
        !this.props.isLoading.setValueOfDSEtoDataPeriod) ||
      (prevProps.isLoading.updateValueOfDSEtoDataPeriod &&
        !this.props.isLoading.updateValueOfDSEtoDataPeriod)
    ) {
      if (
        (!this.props.errors.setValueOfDSEtoDataPeriod &&
        !this.props.errors.updateValueOfDSEtoDataPeriod)
      ) {
        
        this.updateStudentData(true, false, false);
      } else {
        toastr.error(
          "Error",
          this.props.errors.setValueOfDSEtoDataPeriod ||
          this.props.errors.updateValueOfDSEtoDataPeriod ||
          "Error"
        );
      }
    }

    if ( 
      (prevProps.isLoading.setDiagnosticFollowUptoDataPeriod &&
        !this.props.isLoading.setDiagnosticFollowUptoDataPeriod) ||
      (prevProps.isLoading.deleteDiagnosticFollowUptoDataPeriod &&
        !this.props.isLoading.deleteDiagnosticFollowUptoDataPeriod)
    ) {
      if (
        (!this.props.errors.setDiagnosticFollowUptoDataPeriod &&
        !this.props.errors.deleteDiagnosticFollowUptoDataPeriod)
      ) {
        
        this.updateStudentData(true, false, false);
      } else {
        toastr.error(
          "Error",
          this.props.errors.setDiagnosticFollowUptoDataPeriod ||
          this.props.errors.deleteDiagnosticFollowUptoDataPeriod ||
          "Error"
        );
      }
    }


    if (this.props.match.params.tabName !== prevProps.match.params.tabName) {
      this.calculateTableSize();
    }
    if (
      ((prevProps.isLoading.addAssessmentToDataPeriod &&
        !this.props.isLoading.addAssessmentToDataPeriod)
      )
    ) {
      this.props.getDataPeriods();
      this.props.getTeachers();
    }

     if (
      (
        (prevProps.isLoading.uploadEvidenceData &&
          !this.props.isLoading.uploadEvidenceData) ||
        (prevProps.isLoading.uploadUndefinedAssessmentData &&
          !this.props.isLoading.uploadUndefinedAssessmentData) ||
        ((prevProps.isLoading.uploadAssessmentData &&
        !this.props.isLoading.uploadAssessmentData) && !this.props.errors.uploadAssessmentData)
      )
      && (this.props.userInfo?.profile.current_assignment?.role !== UserAssignmentRole.DISTRICT_OWNER)
    ) {
      this.props.getDataPeriods();
      this.props.getTeachers();
      
    }

    if (prevState.scrollToRow) {
      this.setState({ scrollToRow: undefined });
    }
    if (
      prevProps.isLoading.getEvidenceData &&
      !this.props.isLoading.getEvidenceData
    ) {
      this.updateStudentData(true, false);
    }

    if (
      prevProps.isLoading.addTargetBehaviorToDataPeriod &&
      !this.props.isLoading.addTargetBehaviorToDataPeriod
    ) {
      if (!this.props.errors.addTargetBehaviorToDataPeriod) {
        
        this.updateStudentData(true, false);
      } else {
        toastr.error("Error", this.props.errors.addTargetBehaviorToDataPeriod);
      }
    }
if(this.props.evidencePeriodData &&
  (prevProps.evidencePeriodData !== this.props.evidencePeriodData)
){
    if(
      prevProps.teacherIdFilter !== this.props.teacherIdFilter
      || prevProps.schoolIdsFilter !== this.props.schoolIdsFilter 
      || prevProps.classFilter !== this.props.classFilter 
      || prevProps.gradeLevelFilter !== this.props.gradeLevelFilter 
      || prevProps.studentsFilter !== this.props.studentsFilter 
      || prevProps.currentDataPeriod !== this.props.currentDataPeriod 
      || prevProps.raceFilter?.length !== this.props.raceFilter?.length
      || prevProps.raceOtherFilter?.length !== this.props.raceOtherFilter?.length 
      || prevProps.genderFilter !== this.props.genderFilter 
      || prevProps.specialEducationFilter !== this.props.specialEducationFilter 
      || prevProps.ellFilter !== this.props.ellFilter 
      || prevProps.sldFilter !== this.props.sldFilter 
      || prevProps.freeOrReducedLunchFilter !== this.props.freeOrReducedLunchFilter
      ) {
    const evidencePeriodData = this.props.evidencePeriodData
      let sortedResult: StudentRow[] = this.handleMultiSortExc(this.props.dataSort, evidencePeriodData)!;
      this.setState((prevState) => ({
        ...prevState,
        evidencePeriodData: {
          ...prevState.evidencePeriodData!,
          student_rows: sortedResult,
        }
      }),() => {
        this.calculateTableSize;
      });
    }
  }

    if (
      prevProps.isLoading.addStudentsToDataPeriod &&
      !this.props.isLoading.addStudentsToDataPeriod
    ) {
      if (!this.props.errors.addStudentsToDataPeriod) {
        
        this.updateStudentData(false, false);
      } else {
        toastr.error("Failed", this.props.errors.addStudentsToDataPeriod);
      }
    }
    if (
      prevProps.dataSort?.activeSort.length !==
      this.props.dataSort?.activeSort.length
    ) {
      if(this.props.dataSort?.isResetColumnSort) {
        this.updateStudentData(false, false, false);
      }
    }
    { '' }
    if (
      prevProps.isLoading.addAssessmentToDataPeriod &&
      !this.props.isLoading.addAssessmentToDataPeriod
    ) {
      if (!this.props.errors.addAssessmentToDataPeriod) {
        this.setState({ scrollToRow: 0 });
        
        this.updateStudentData(true, false, false);
      } else {
        toastr.error("Failed", this.props.errors.addAssessmentToDataPeriod);
      }
    }

    if (
      this.props.currentDataPeriod &&
      prevProps.isLoading.deleteEvidenceColumnsGroup &&
      !this.props.isLoading.deleteEvidenceColumnsGroup
    ) {
      this.updateStudentData(true, false, false);
      //this.props.getEvidenceInDataPeriod(this.props.currentDataPeriod.id);
    }

    if (
      prevProps.isLoading.changeStudentDSEGrade &&
      !this.props.isLoading.changeStudentDSEGrade
    ) {
      this.updateStudentData(true, false, false);
    }

    if (
      prevProps.isLoading.createDiagnosticInfoColumn &&
      !this.props.isLoading.createDiagnosticInfoColumn
    ) {
      this.updateStudentData(true, false, false);
    }

    if (
      this.props.currentDataPeriod &&
      prevProps.isLoading.addStudentSkills &&
      !this.props.isLoading.addStudentSkills
    ) {
      if (this.props.isEnterSpecificSkillActive) {
        this.props.resetFilterAction();
        this.props.resetSortAction();
        this.props.resetPagination();
        this.props.getEvidenceInDataPeriod(this.props.currentDataPeriod.id);
        this.props.clickGotIt();
      } else {
        this.updateStudentData(true, false, false);
      }
    }

    if (
      prevProps.isLoading.deleteDataStudentEntry &&
      !this.props.isLoading.deleteDataStudentEntry
    ) {
      this.updateStudentData(true, false, false);
    }

    if (
      prevProps.isLoading.addStudentBehaviorsToDataPeriod &&
      !this.props.isLoading.addStudentBehaviorsToDataPeriod
    ) {
      this.updateStudentData(true, true, false);
    }

    if (
      prevProps.isLoading.addExistingBehaviorEcgToDataPeriod &&
      !this.props.isLoading.addExistingBehaviorEcgToDataPeriod
    ) {
      this.updateStudentData(true, false, false);
    }

    if (
      prevProps.isLoading.addBehaviorScreenerEcgToDataPeriod &&
      !this.props.isLoading.addBehaviorScreenerEcgToDataPeriod
    ) {
      this.updateStudentData(true, false, false);
    }

    if (
      prevProps.isLoading.updateStudentDetails &&
      !this.props.isLoading.updateStudentDetails
    ) {
      if (!this.props.errors.updateStudentDetails) {
        this.updateStudentData(true, false, false);
      } else {
        toastr.error("Failed", this.props.errors.updateStudentDetails);
      }
    }
    
    if (
      prevProps.isLoading.addStudents &&
      !this.props.isLoading.addStudents
    ) {
      if (!this.props.errors.addStudents) {
        this.updateStudentData(true, false, false);
      } else {
        if(!Array.isArray(this.props.errors.addStudents)) {
          toastr.error("Failed", this.props.errors.addStudents);
        }
      }
    }

    if(prevProps.isLoading.assignTeachersToStudent && 
      !this.props.isLoading.assignTeachersToStudent) {
        this.updateStudentData(true, false, false);
      }

    if (
      // update the column of students when the list of teachers (classes) of a student is changed
      ((prevProps.isLoading.assignTeachersToStudent &&
        !this.props.isLoading.assignTeachersToStudent) ||
        (prevProps.isLoading.updateClassesLinkedToStudent &&
          !this.props.isLoading.updateClassesLinkedToStudent)) &&
      this.props.selectedStudent
    ) {
      this.setState((state) => ({
        ...state,
        evidencePeriodData: {
          ...state.evidencePeriodData!,
          student_rows: state.evidencePeriodData!.student_rows.map((sr) =>
            sr.student.id === this.props.selectedStudent?.id
              ? { ...sr, student: this.props.selectedStudent! }
              : sr
          ),
        },
      }));
    }

    if (
      prevProps.showTopBar !== this.props.showTopBar ||
      prevProps.showGroupingStudentInfo !== this.props.showGroupingStudentInfo
    ) {
      this.calculateTableSize();
    }
    if (this.props.evidencePeriodData && (JSON.stringify(prevProps.dataSort) !== JSON.stringify(this.props.dataSort)
    )) {
      if(this.props.dataSort?.isColumnSortApplied) {
        let sortedResult: StudentRow[] = this.handleMultiSortExc(this.props.dataSort, this.state.evidencePeriodData!)!;
        this.setState((prevState) => ({
          ...prevState,
          evidencePeriodData: {
            ...prevState.evidencePeriodData!,
            student_rows: sortedResult,
          }
        }));
      }
      
    }

    if (
      prevProps.isLoading.updateClassesLinkedToStudent &&
      !this.props.isLoading.updateClassesLinkedToStudent
    ) {
      this.updateStudentData(true, false, false);
    }

    if (
      prevProps.isLoading.updateCustomColorCriteria &&
      !this.props.isLoading.updateCustomColorCriteria
    ) {
        if(!this.props.errors.updateCustomColorCriteria) {
          this.updateStudentData(true, false, false);
        }
    }

    if (
      prevProps.isLoading.updateAssessment &&
      !this.props.isLoading.updateAssessment
    ) {
      if(!this.props.errors.updateAssessment) {
         this.updateStudentData(true, false, false);
      }
    }

    if (this.state.evidencePeriodData !== prevState.evidencePeriodData) {
      this.calculateTableSize();
    }

    if((this.state.sorting.column 
      ? this.state.sorting.column !== prevState.sorting.column 
      : this.state.sorting.evidenceType !== prevState.sorting.evidenceType)) {
        if (this.state.sorting.sortingCount <= 2) {
          const { sorting } = this.state;
          let sortStudentRow: any;
          if (this.state.sorting.measurement) {
            const evidenceColumnGroup:
              | EvidenceColumnGroup
              | undefined = this.props.evidencePeriodData!.evidence_column_groups.find(
                (x) => x.id === sorting.measurement!.evidenceColumnGroupId
              );
            if (evidenceColumnGroup) {
              const evidenceColumn:
                | EvidenceColumn
                | undefined = evidenceColumnGroup.evidence_columns.find(
                  (x) => x.id === sorting.measurement!.evidenceColumnId
                );
              if (evidenceColumn) {
                sortStudentRow = this.sortStudentRowsByDse(evidenceColumn, 'asc', evidenceColumnGroup.meta_group_type)
              }
            }
          } else if (sorting.column) {
            sortStudentRow = this.sortStudentRowsByName(
              sorting.column as ColumnNames,
              'asc'
            );
          }
          this.setState((prevState) => ({ 
            ...prevState,
            evidencePeriodData: {
              ...prevState.evidencePeriodData!,
              student_rows: prevState.evidencePeriodData!.student_rows.sort(
                sortStudentRow
              )
            },
            sorting: {
              ...prevState.sorting,
              column: this.state.sorting.column,
              measurement: this.state.sorting.measurement,
              direction: "asc",
              sortingCount: (this.state.sorting.evidenceType == EvidenceType.DiagnosticFollowUp ) ? 0 : 1,
              evidenceType: this.state.sorting.evidenceType
            }
          }));
          
        }

      }

  }

  demographicsFilter = (studentRows: StudentRow[] = []) => {
    const {
      specialEducationFilter,
      ellFilter,
      sldFilter,
      freeOrReducedLunchFilter,
    } = this.props;
    return dataHelpers.demographicsFilter(
      studentRows,
      specialEducationFilter,
      ellFilter,
      sldFilter,
      freeOrReducedLunchFilter
    );
  }

  // rowsFilter = (studentRow: StudentRow) => {
  //   return dataHelpers.rowsFilter(studentRow, this.props as any);
  // };

  teachersFilter = (studentRow: StudentRow) => {
    return dataHelpers.teachersFilter(studentRow, this.props.teacherIdFilter);
  };

  interventionGroupFilter = (studentRow: StudentRow) => {
    return dataHelpers.interventionGroupFilter(studentRow, this.props.interventionGroup);
  };

  getDisplayedColumnsFromStorage = (evidencePeriodData: EvidencePeriodData) => {
    return dataHelpers.getDisplayedColumnsFromStorage(evidencePeriodData, this.state.displayedColumns);
  };

  updateStudentData = (
    needDataFiltering: boolean = true,
    needEditing: boolean = true,
    needInterviewUpdating: boolean = true
  ) => {
    if (needInterviewUpdating) {
      //this.props.getInterviews(); //todo maybe move to another place
    }
    if(this.props.evidencePeriodData) {
      this.setState(
        (prevState) => ({
          ...prevState,
          isDistrictOwner: 
                  this.props.userInfo?.profile.current_assignment?.role 
                  === UserAssignmentRole.DISTRICT_OWNER,
          scrollToRow: needDataFiltering ? prevState.scrollToRow : 1,
          sorting: needDataFiltering
            ? prevState.sorting
            : { measurement: undefined, column: undefined, direction: "desc", sortingCount: 0, evidenceType: 0 },
          evidencePeriodData: {
            ...this.props.evidencePeriodData!,
            student_rows: needDataFiltering
              ? this.getSortedStudentRows()
              : this.props.evidencePeriodData?.student_rows!,
          },
          displayedColumns: this.getDisplayedColumnsFromStorage(this.props.evidencePeriodData!),
          studentEditingRows: this.props.evidencePeriodData!.student_rows.map(
            (studentRow) => {
              return {
                studentId: studentRow.student.id!,
                evidenceColumnGroups: this.props.evidencePeriodData!.evidence_column_groups.map(
                  (evidenceColumnGroup) => {
                    if (prevState.studentEditingRows.length > 0) {
                      const studentEditingRow = prevState.studentEditingRows.find(
                        (x) => x.studentId === studentRow.student.id!
                      );
                      const existingEvidenceColumnGroup:
                        | EvidenceColumnGroupEditing
                        | undefined = studentEditingRow
                          ? studentEditingRow.evidenceColumnGroups.find(
                            (x) =>
                              x.evidenceColumnGroupId === evidenceColumnGroup.id
                          )
                          : undefined;
                      if (existingEvidenceColumnGroup) {
                        return {
                          evidenceColumnGroupId: evidenceColumnGroup.id,
                          evidenceColumnEditingStatuses: evidenceColumnGroup.evidence_columns.map(
                            (evidenceColumn) => {
                              const value = this.getEvidenceValue(
                                evidenceColumn,
                                studentRow
                              );
                              const evidenceColumnEditingStatus = existingEvidenceColumnGroup.evidenceColumnEditingStatuses.find(
                                (editingStatus) =>
                                  editingStatus?.evidenceColumnId ===
                                  evidenceColumn.id
                              )!;
                              if (
                                value !== undefined &&
                                evidenceColumnEditingStatus.value === value
                              ) {
                                return {
                                  evidenceColumnId: evidenceColumn.id,
                                  isEdited: false,
                                  value: undefined,
                                };
                              }
                              return evidenceColumnEditingStatus;
                            }
                          ),
                        };
                      }
                    }
                    return {
                      evidenceColumnGroupId: evidenceColumnGroup.id,
                      evidenceColumnEditingStatuses: evidenceColumnGroup.evidence_columns.map(
                        (evidenceColumn) => {
                          return {
                            evidenceColumnId: evidenceColumn.id,
                            isEdited: needEditing,
                          };
                        }
                      ),
                    };
                  }
                ),
              };
            }
          ),
          selectedStudents: this.props.evidencePeriodData?.student_rows
                            .filter((sr) => prevState.selectedStudents
                              .some((s) => s.id === sr.student.id)
                            ).map((sr) => sr.student) || [],
        }),
        () => {
          return this.calculateTableSize
        }
      );
    }

    this.calculateMinimumGrade(this.props.evidencePeriodData?.student_rows!);
  };

  getEvidenceValue = (
    evidenceColumn: EvidenceColumn,
    studentRow: StudentRow
  ) => {
    return dataHelpers.getEvidenceValue(evidenceColumn, studentRow);
  };

  filterDisplayedColumns = (evidenceColumnGroupId: number) => (
    evidenceColumn: EvidenceColumn
  ) => {
    return dataHelpers.filterDisplayedColumns(evidenceColumnGroupId, this.state.displayedColumns)(evidenceColumn);
  };

  isChecked = (evidenceColumnGroupId: number, evidenceColumnId: number) => {
    if(!this.state.displayedColumns.length) {
      this.setState(
        (prevState) => ({
          ...prevState,
          displayedColumns: JSON.parse(
            localStorage.getItem(LocalStorageKeys.DisplayedColumns) || "[]"
          ),
        }));
    }
    const group = this.state.displayedColumns.find(
      (x) => x.evidenceColumnGroupId === evidenceColumnGroupId
    );
    if (group) {
      const col = group.evidenceColumns.find(
        (x) => x.evidenceColumnId === evidenceColumnId
      );
      if (col) {
        return col.show;
      }
    }
    return false;
  };

  getSortedStudentRows = () => {
    if (this.props.evidencePeriodData) {
      const filteredStudentsRows = 
      // commented for data interview page optimization RC-1920
      // this.demographicsFilter(this.props
      //   .evidencePeriodData?.student_rows)?.filter(this.rowsFilter)
      this.props
        .evidencePeriodData?.student_rows.filter(this.interventionGroupFilter);
      const { sorting } = this.state;
      if (sorting.measurement) {
        const evidenceColumnGroup:
          | EvidenceColumnGroup
          | undefined = this.props.evidencePeriodData!.evidence_column_groups.find(
            (x) => x.id === sorting.measurement!.evidenceColumnGroupId
          );
        if (evidenceColumnGroup) {
          const evidenceColumn:
            | EvidenceColumn
            | undefined = evidenceColumnGroup.evidence_columns.find(
              (x) => x.id === sorting.measurement!.evidenceColumnId
            );
          if (evidenceColumn) {
            return filteredStudentsRows.sort(
              this.sortStudentRowsByDse(evidenceColumn, sorting.direction, evidenceColumnGroup.meta_group_type)
            );
          }
        }
      } else if (sorting.column) {
        return filteredStudentsRows.sort(
          this.sortStudentRowsByName(
            sorting.column as ColumnNames,
            sorting.direction
          )
        );
      }
      return filteredStudentsRows;
    }
    return [];
  };

  handleSort = (columnName: ColumnNames) => () => {
    const direction = (this.state.sorting.direction === "asc") && (this.state.sorting.column === columnName) ? "desc" : "asc";
    const sortedData = this.state.evidencePeriodData!.student_rows.sort(
      (this.state.sorting.column === columnName) && (this.state.sorting.sortingCount <= 1) 
      ? this.sortStudentRowsByName(columnName, direction)
      : this.sortStudentRowsByName(ColumnNames.STUDENT_ROW, 'asc')
    );
    this.setState((prevState) => ({
      ...prevState,
      evidencePeriodData: {
        ...prevState.evidencePeriodData!,
        student_rows: sortedData,
      },
      sorting: {
        ...prevState.sorting,
        direction: (this.state.sorting.column == columnName) && (this.state.sorting.sortingCount <= 1) ? direction : "desc" ,
        measurement: undefined,
        column: columnName,
        sortingCount: (this.state.sorting.column == columnName) && (this.state.sorting.sortingCount <= 1) ? prevState.sorting.sortingCount + 1: 0,
        evidenceType: 0
      },
    })); 
  };

  handleDseSort = (
    evidence_column: EvidenceColumn,
    evidenceColumnGroup: EvidenceColumnGroup
  ) => () => {
    const direction = (this.state.sorting.direction === "asc") && (
      this.state.sorting.column 
      ? this.state.sorting.column == evidence_column?.measurement?.column_name
      : this.state.sorting.evidenceType == evidence_column.evidence_type
    ) ? "desc" : "asc";
    const isSortedColumnSame = (this.state.sorting.column 
      ? evidence_column?.measurement?.column_name == this.state.sorting.column 
      : evidence_column.evidence_type == this.state.sorting.evidenceType) ;
    const sortedData = this.state.evidencePeriodData!.student_rows.sort(
      this.sortStudentRowsByDse(evidence_column, isSortedColumnSame ? direction : "asc", evidenceColumnGroup.meta_group_type)
    );
    this.setState((prevState) => ({
      ...prevState,
      evidencePeriodData: {
        ...prevState.evidencePeriodData!,
        student_rows: sortedData,
      },
      sorting: {
        direction: isSortedColumnSame ? direction : "asc",
        column: evidence_column?.measurement?.column_name,
        measurement: {
          evidenceColumnGroupId: evidenceColumnGroup.id,
          evidenceColumnId: evidence_column.id,
        },
        sortingCount: 
          isSortedColumnSame 
          ? prevState.sorting.sortingCount + 1 : 1,
        evidenceType: evidence_column.evidence_type
      },
    }));
  };

  getSortFunction = (sortOrder: any) => getSortFunction(sortOrder);

  handleMultiSortExc = (
    dataSort: any,
    evidencePeriodData: EvidencePeriodData
  )  => {
    const sortOptions = dataSort?.activeSort;
    
    if (sortOptions.length) {
      const combined: any = sortOptions[0].col.student_entries.map((std: any) => { return { student_id: std.student_id } });
      const sortOrder: any = [];
      for (let i in sortOptions) {
        for (let j in sortOptions[i].col.student_entries) {
          const index = combined.findIndex(
            (obj: any) => obj.student_id.toString() === sortOptions[i].col.student_entries[j].student_id.toString()
            )
          if(combined[index])
            combined[index][sortOptions[i].col.measurement.column_name] = parseInt(sortOptions[i].col.student_entries[j].value);
        }
        sortOrder.push({ key: sortOptions[i].col.measurement.column_name, order: sortOptions[i].direction });
        const direction = sortOptions[i].direction !== "Ascending" ? "desc" : "asc";
      }
          
      let columnSort = combined.sort(this.getSortFunction(sortOrder));
      
      const sortStudentIds = columnSort.map((et: any) => et.student_id);
      
      let sortedResult = evidencePeriodData?.student_rows.sort((a, b) => sortStudentIds.indexOf(a.student.id) - sortStudentIds.indexOf(b.student.id));
      return sortedResult;
    }
    return evidencePeriodData?.student_rows;
  };

  getStudentGrade = (studentId?: number): Grade | undefined => {
    return dataHelpers.getStudentGrade(this.state.evidencePeriodData, studentId);
  };

  sortStudentRowsByName = (
    columnName: ColumnNames,
    direction: "asc" | "desc"
  ) => {
    return dataHelpers.sortStudentRowsByName(columnName, direction, this.state.evidencePeriodData);
  };

  sortStudentRowsByDse = (
    evidenceColumn: EvidenceColumn,
    direction: "asc" | "desc",
    evidenceGroupType: string
  ) => {
    return dataHelpers.sortStudentRowsByDse(evidenceColumn, direction, evidenceGroupType, this.state.evidencePeriodData);
  };

  handleViewBenchmarks = (
    assessment: AssessmentData,
    selectedEvidenceColumnGroupId: number,
    selectedEvidenceColumn: EvidenceColumn,
    isBehaviorPrimary: boolean,
  ) => () => {
    this.setState({
      selectedEvidence: {
        assessmentName: assessment.name,
        evidenceColumnGroupId: selectedEvidenceColumnGroupId,
        evidenceColumn: selectedEvidenceColumn,
        isBehaviorPrimaryScreening: isBehaviorPrimary,
        useGradeSpecificColorCriteria: assessment.use_grade_specific_color_criteria!,
        withReadingAlgorithm: assessment.with_reading_algorithm!,
        isSystemAssessment: assessment.is_system_assessment!
      },
    });
    this.props.openViewBenchmarksModal();
  };

  updateMeasurementCustomColorCriteria = (editedMeasurement: Measurement) => {
    if (
      editedMeasurement.custom_color_criteria !==
      this.state.selectedEvidence!.evidenceColumn.measurement
        .custom_color_criteria
    ) {
      this.setState((prevState) => {
        return {
          ...prevState,
          evidencePeriodData: {
            ...prevState.evidencePeriodData!,
            evidence_column_groups: prevState.evidencePeriodData!.evidence_column_groups.map(
              (evidenceColumnGroup) => {
                if (
                  evidenceColumnGroup.id ===
                  this.state.selectedEvidence!.evidenceColumnGroupId
                ) {
                  return {
                    ...evidenceColumnGroup,
                    evidence_columns: evidenceColumnGroup.evidence_columns.map(
                      (evidenceColumn) => {
                        if (
                          evidenceColumn.id ===
                          this.state.selectedEvidence!.evidenceColumn.id
                        ) {
                          return {
                            ...evidenceColumn,
                            measurement: {
                              ...evidenceColumn.measurement,
                              custom_color_criteria:
                                editedMeasurement.custom_color_criteria,
                            },
                          };
                        }
                        return evidenceColumn;
                      }
                    ),
                  };
                }
                return evidenceColumnGroup;
              }
            ),
          },

        };
      });
    }
  };

  handleViewBenchmarksModalHide = (editedMeasurement?: Measurement) => {
    if (editedMeasurement) {
      this.updateMeasurementCustomColorCriteria(editedMeasurement);
    }
    this.props.hideViewBenchmarksModal();
  };

  handleDisplayedColumnsChange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number
  ) => () => {
    const displayedColumns = this.state.displayedColumns.map(
      (displayedColumn) => {
        if (displayedColumn.evidenceColumnGroupId === evidenceColumnGroupId) {
          const displayedColumnsNum = displayedColumn.evidenceColumns.filter(
            (x) => x.show
          ).length;
          const result: DisplayedColumn = {
            ...displayedColumn,
            evidenceColumns: displayedColumn.evidenceColumns.map(
              (evidenceColumn) => {
                if (evidenceColumn.evidenceColumnId === evidenceColumnId) {
                  return {
                    ...evidenceColumn,
                    show: !evidenceColumn.show
                      ? !evidenceColumn.show
                      : displayedColumnsNum > 1
                        ? !evidenceColumn.show
                        : evidenceColumn.show,
                  };
                }
                return evidenceColumn;
              }
            ),
          };

          const found =
            result.evidenceColumns.filter(
              (ec) => ec.evidenceColumnId === evidenceColumnId
            ).length > 0;

          if (!found) {
            result.evidenceColumns.push({
              evidenceColumnId: evidenceColumnId,
              show: true,
            });
          }

          return result;
        }
        return displayedColumn;
      }
    );
    this.setState({
      displayedColumns: displayedColumns,
    });
    const storageData = JSON.parse(
      localStorage.getItem(LocalStorageKeys.DisplayedColumns) || "[]"
    ) as Array<DisplayedColumn>;
    const mergedData = storageData
      .filter(
        (data) =>
          !displayedColumns.some(
            (dc) => dc.evidenceColumnGroupId === data.evidenceColumnGroupId
          )
      )
      .concat(displayedColumns);
    localStorage.setItem(
      LocalStorageKeys.DisplayedColumns,
      JSON.stringify(mergedData)
    );
  };

  findDataStudentEntry = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => {
    return dataHelpers.findDataStudentEntry(
      this.state.evidencePeriodData,
      evidenceColumnGroupId,
      evidenceColumnId,
      studentId
    );
  };

  findEvidenceType = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
  ) => {
    return dataHelpers.findEvidenceType(
      this.state.evidencePeriodData,
      evidenceColumnGroupId,
      evidenceColumnId
    );
  };

  // Helper function to calculate min/max ranges from criteria array
  calculateRangeFromCriteria = (criteria: Array<any>) =>
    calculateRangeFromCriteria(criteria);

  findColorCriteriaRange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    grade?: Grade,
    timePeriod?: string
  ) => {
    return dataHelpers.findColorCriteriaRange(
      this.state.evidencePeriodData,
      evidenceColumnGroupId,
      evidenceColumnId,
      grade,
      timePeriod
    );
  };

  handleStudentDataChange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    propertyValueName: string,
    value: number | boolean
  ) => {
    const dataStudentEntry = this.findDataStudentEntry(
      evidenceColumnGroupId,
      evidenceColumnId,
      studentId
    );
     const evidenceColumnType = this.findEvidenceType(
      evidenceColumnGroupId,
      evidenceColumnId
    );
    if (dataStudentEntry) {
      if(evidenceColumnType == EvidenceType.DiagnosticFollowUp) {
        const stdId = dataStudentEntry.entry_id;
        if (stdId) {
          //updated STE
          this.props.deleteDiagnosticFollowUptoDataPeriod(stdId).then((result:any)=> {
            if(result) {
              this.changeCellEditingStatus(
                evidenceColumnGroupId,
                evidenceColumnId,
                studentId,
                value,
                true
              );
            }
          });
          return;
        }
      } else {
        if (value === +dataStudentEntry.value!) {
          this.changeCellEditingStatus(
            evidenceColumnGroupId,
            evidenceColumnId,
            studentId,
            undefined,
            true
          );
          return; //value hasn't changed - just close
        }
        const stdId = dataStudentEntry.entry_id;
        if (stdId) {
          //updated STE
          if(evidenceColumnType == EvidenceType.Data) {
            const {globalRangeMax, globalRangeMin } = this.findColorCriteriaRange(
              evidenceColumnGroupId,
              evidenceColumnId,
              dataStudentEntry.grade,
              this.props.currentDataPeriod?.time_period
            );
            if (+value < (globalRangeMin! || 0)
                || +value > (globalRangeMax! || 2000)) {
              toastr.info('Info',
                `Value is outside the min–max score range, so benchmarks aren’t available.`
              );
            }
          }

          this.props.updateValueOfDSEtoDataPeriod(evidenceColumnGroupId, stdId, {
            [propertyValueName]: value,
          });
          return;
        }
      }
    }
    //new STE
    if(evidenceColumnType == EvidenceType.DiagnosticFollowUp) {
      this.props.setDiagnosticFollowUptoDataPeriod(evidenceColumnGroupId, {
        student_id: studentId,
        evidence_column_id: evidenceColumnId,
        [propertyValueName]: value,
      }).then((result:any)=> {
        if(result) {
          this.changeCellEditingStatus(
            evidenceColumnGroupId,
            evidenceColumnId,
            studentId,
            value,
            true
          );
        }
      });
    } else {
      if(evidenceColumnType == EvidenceType.Data) {
        let grade: Grade | undefined = dataStudentEntry?.grade;
        if(!dataStudentEntry) {
          const studentRow = this.props.evidencePeriodData?.student_rows.find((studentRow) => studentRow.student.id === studentId);
          if(studentRow) {
            grade = studentRow.grade as Grade;
          }
        } 
        const {globalRangeMax, globalRangeMin } = this.findColorCriteriaRange(
          evidenceColumnGroupId,
          evidenceColumnId,
          grade,
          this.props.currentDataPeriod?.time_period
        );
        if (+value < (globalRangeMin! || 0)
            || +value > (globalRangeMax! || 2000)) {
          toastr.info('Info',
            `Value is outside the min–max score range, so benchmarks aren’t available.`
          );
        }
      }
      this.props.setValueOfDSEtoDataPeriod(evidenceColumnGroupId, {
        student_id: studentId,
        evidence_column_id: evidenceColumnId,
        [propertyValueName]: value,
      });
    }
  };

  handleChangesApply = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: number | boolean
  ) => () => {
    if (value !== undefined) {
      this.handleStudentDataChange(
        evidenceColumnGroupId,
        evidenceColumnId,
        studentId,
        "value",
        typeof value == "boolean" ? value : +value
      );
    }
  };

  handleKeyDown = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      const { value } = event.target as HTMLInputElement;
      if (value !== "") {
        this.handleStudentDataChange(
          evidenceColumnGroupId,
                   evidenceColumnId,
          studentId,
          "value",
          +value
        );
      }
    }
  };

  handleSelectedValueChange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => (value: ValueType<PossibleValue, false>) => {

    if (value) {
      this.changeCellEditingStatus(
        evidenceColumnGroupId,
        evidenceColumnId,
        studentId,
        (value as PossibleValue).order
      );
      this.handleStudentDataChange(
        evidenceColumnGroupId,
        evidenceColumnId,
        studentId,
        "selected_value_order",
        (value as PossibleValue).order
      );
    }
  };

  handleGradeValueChange = (studentId: number, grade: Grade) => {
    if (this.props.currentDataPeriod) {
      this.props.changeStudentDSEGrade(
        this.props.currentDataPeriod.id,
        studentId,
        grade
      );
    }
  };

  handleCellEditFormChange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: string
  ) => () => {
    const evidenceColumnGroup: EvidenceColumnGroup | undefined =
      this.props.evidencePeriodData?.evidence_column_groups
        .find((ecg: EvidenceColumnGroup) => ecg.id == evidenceColumnGroupId); 
    if (!this.props.isReadonly && (evidenceColumnGroup?.assessment?.name !== 'SRSS')) {
      this.changeCellEditingStatus(
        evidenceColumnGroupId,
        evidenceColumnId,
        studentId,
        value,
        true
      );
    }
  };

  changeCellEditingStatus = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: string | number | boolean,
    isCloseAction?: boolean
  ) => {
    const evidenceColumnType = this.findEvidenceType(
      evidenceColumnGroupId,
      evidenceColumnId
    );
    this.setState((prevState) => ({
      studentEditingRows: prevState.studentEditingRows.map((studentRow) => {
        if (studentRow.studentId === studentId) {
          return {
            ...studentRow,
            evidenceColumnGroups: studentRow.evidenceColumnGroups.map(
              (evidenceColumnGroup) => {
                if (
                  evidenceColumnGroup.evidenceColumnGroupId ===
                  evidenceColumnGroupId
                ) {
                  return {
                    ...evidenceColumnGroup,
                    evidenceColumnEditingStatuses: evidenceColumnGroup.evidenceColumnEditingStatuses.map(
                      (evidenceColumnEditingStatus) => {
                        if (
                          evidenceColumnEditingStatus?.evidenceColumnId ===
                          evidenceColumnId
                        ) {
                          return {
                            ...evidenceColumnEditingStatus,
                            isEdited: isCloseAction
                              ? !evidenceColumnEditingStatus.isEdited
                              : evidenceColumnEditingStatus.isEdited,
                            value: evidenceColumnType == EvidenceType.DiagnosticFollowUp 
                                    ? !!value :(value ? +value : undefined),
                          };
                        }
                        return evidenceColumnEditingStatus;
                      }
                    ),
                  };
                }
                return evidenceColumnGroup;
              }
            ),
          };
        }
        return studentRow;
      }),
    }));
    return Promise.resolve();
  };

  handleStudentRowEditingChange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    this.changeCellEditingStatus(
      evidenceColumnGroupId,
      evidenceColumnId,
      studentId,
      value
    );
  };

  handleDiagnosticFollowUpEditingChange = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: string
  ) => {
    let isDiagnosticFollowUp = true;
    if(value) {
      if(value == 'true') {
        isDiagnosticFollowUp = false;
      } else if(value == 'false') {
        isDiagnosticFollowUp = true;
      }
    }
    this.handleStudentDataChange(
      evidenceColumnGroupId,
      evidenceColumnId,
      studentId,
      "value",
      isDiagnosticFollowUp
    )
  };

  checkSorting = (evidenceColumnGroup: EvidenceColumnGroup, evidenceColumn: EvidenceColumn) => {
    const { sorting } = this.state;
    if (!sorting.measurement) return undefined;
    if (
      sorting.measurement.evidenceColumnGroupId === evidenceColumnGroup.id &&
      sorting.measurement.evidenceColumnId === evidenceColumn.id
    ) {
      if(sorting.evidenceType == EvidenceType.DiagnosticFollowUp 
        ? sorting.sortingCount == 1 
        : sorting.column == evidenceColumn?.measurement?.column_name && sorting.sortingCount == 3) {
        this.setState((prevState) => ({ 
          ...prevState,
          evidencePeriodData: {
            ...prevState.evidencePeriodData!,
            student_rows: prevState.evidencePeriodData!.student_rows.sort(
              this.sortStudentRowsByName(ColumnNames.STUDENT_ROW, "asc")
            )
          },
          sorting: {
            ...prevState.sorting,
            column: undefined,
            measurement: undefined,
            direction: "desc",
            sortingCount: 0,
            evidenceType: 0
          }
        }));
        return undefined;
      } else {
        return sorting.direction;
      }
    }
    return undefined;
  };

  handleStudentCheck = (student: Student) => (
    event: React.ChangeEvent<any>
  ) => {
    const { checked } = event.target;
    if (checked) {
      this.setState((prevState) => ({
        ...prevState,
        selectedStudents: [...prevState.selectedStudents, student],
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        selectedStudents: prevState.selectedStudents.filter(
          (selectedStudent) => selectedStudent.id !== student.id
        ),
      }));
    }
  };

  handleSelectedStudentsAdd = () => {
    this.props.addStudentsToNewGroup(this.state.selectedStudents);
    this.setState({ selectedStudents: [] });
  };

  handleSelectedStudentClassAdd = () => {
    const {
      currentDataPeriod
    } = this.props;
    this.setState({showDropDown: !this.state.showDropDown}, () => {
      if(this.state.showDropDown) {
        let grade = this.state.selectedStudents[0].grade;
        this.props.getAllClasses(currentDataPeriod!.id, grade);
      }
    })
  }

  resetState = () => {
    this.setState({ selectedStudents: [] });
  }

  getColumnKey = (
    evidenceColumnGroupId: number,
    evidenceColumnId: number
  ) => {
    return `ecg-${evidenceColumnGroupId}-ec-${evidenceColumnId}`;
  };

  getDefaultColumnWidth = (
    evidenceColumnGroup: EvidenceColumnGroup,
    evidenceColumn: EvidenceColumn
  ) => {
    return dataHelpers.getColumnWidth(
      evidenceColumnGroup,
      evidenceColumn,
      this.props.isCompressedViewOfDataTable,
      this.props.minimal,
      this.state.displayedColumns
    );
  };

  getColumnWidth = (
    evidenceColumnGroup: EvidenceColumnGroup,
    evidenceColumn: EvidenceColumn
  ) => {
    const columnKey = this.getColumnKey(evidenceColumnGroup.id, evidenceColumn.id);
    const storedWidth = this.state.columnWidths[columnKey];
    
    if (storedWidth !== undefined) {
      return storedWidth;
    }
    
    return this.getDefaultColumnWidth(evidenceColumnGroup, evidenceColumn);
  };

  onColumnResizeEndCallback = (newColumnWidth: number, columnKey: string) => {
    // Set minimum width to prevent columns from disappearing
    const MIN_COLUMN_WIDTH = 50;
    const constrainedWidth = Math.max(newColumnWidth, MIN_COLUMN_WIDTH);
    
    this.setState((prevState) => {
      const newColumnWidths = {
        ...prevState.columnWidths,
        [columnKey]: constrainedWidth,
      };
      
      // Persist to localStorage
      localStorage.setItem(
        LocalStorageKeys.ColumnWidths,
        JSON.stringify(newColumnWidths)
      );
      
      return {
        ...prevState,
        columnWidths: newColumnWidths,
      };
    }, () => {
      // Force table recalculation after resize to ensure all columns are visible
      this.calculateTableSize();
    });
  };

  resetColumnWidths = () => {
    // Clear stored column widths and reset to defaults
    localStorage.removeItem(LocalStorageKeys.ColumnWidths);
    this.setState({
      columnWidths: {}
    }, () => {
      this.calculateTableSize();
    });
  };

  getStudentColumnGroupHeader = () => {
    const isNotTeacher = (this.props.userInfo?.profile.current_assignment?.role 
          !== UserAssignmentRole.TEACHER);
    if (this.props.isPlanning) {
      return (
        <>
          <DataLoadingCell />
          <AddStudentsHeaderCell />
          <div className="parentCell">
            {!this.state.isDistrictOwner ? <CheckStudentsHeaderCell
              selectedStudents={this.state.selectedStudents}
              onClick={this.handleSelectedStudentsAdd}
            /> : ''}
            <div 
              ref={this.teacherClassModalRef}
              onClick={() => this.handleSelectedStudentClassAdd}
            >
              <CheckTeacherClassHeaderCell
                selectedStudents={this.state.selectedStudents}
                onClick={() => this.handleSelectedStudentClassAdd()}
              />

            </div>
            {this.state.showDropDown && (
              <Overlay
               rootClose={true}
               onHide={() => this.setState({showDropDown: false})}
               show={this.state.showDropDown}
               target={this.teacherClassModalRef.current}
               placement={"bottom"}
             >
               <Popover
                 id="popover-basic"
                 style={{ width: "100%", zIndex: 9999999 }}
               >
                 <Popover.Content>
                  <StudentClassesTab
                      students={this.state.selectedStudents}
                      onBackClick={this.handleSelectedStudentClassAdd}
                      onReset={this.resetState}
                  />
                  </Popover.Content>
               </Popover>
              </Overlay>
            )}
            
          </div>
        </>
      );
    } else {
      if (this.props.interventionGroup || this.props.isReadonly) {
        return <div />;
      } else {
        return isNotTeacher ? <AddStudentsHeaderCell />: '';
      }
    }
  };

  getStudentCheckColumn = () => {
    return renderStudentCheckColumn(
      this.props.isPlanning,
      this.state.evidencePeriodData,
      this.props.newGroupStudents,
      this.state.selectedStudents,
      this.handleStudentCheck
    );
  };

  getStudentGroupIconColumn = () => {
    return renderStudentGroupIconColumn(
      this.props.isPlanning,
      this.state.evidencePeriodData,
      this.props.studentInterventionGroups
    );
  };

  handleStudentDragStart = (student: Student) => (
    event: React.DragEvent<Cell>
  ) => {
    if(this.state.isDistrictOwner) {
      event.preventDefault();
    }
    event.dataTransfer.setData("student", JSON.stringify(student));
    const divElement = this.getShadowImageDiv();
    event.dataTransfer.setDragImage(divElement, 175, 25);
    document.body.appendChild(divElement);
  };

  handleStudentDragEnd = (student: Student) => {
    document.body.removeChild(this.shadowImageRef!);
    this.setState((pState) => ({
      ...pState,
      selectedStudents: pState.selectedStudents.filter(
        (ss) => ss.id !== student.id
      ),
    }));
  };

  checkStudentCellDraggable = (student: Student) => {
    return dataHelpers.checkStudentCellDraggable(
      student,
      this.props.isPlanning,
      this.props.newGroupStudents
    );
  };

  getNumberDisplayingColumns = (evidenceColumnGroupId: number): number => {
    return dataHelpers.getNumberDisplayingColumns(evidenceColumnGroupId, this.state.displayedColumns);
  };

  reorderEvidenceColumn = (evidenceColumnGroup: EvidenceColumnGroup[]) => {
    if(evidenceColumnGroup.some((ecg) => ecg?.meta_group_type == META_GROUP_TYPE_NEEDS)) {
      return evidenceColumnGroup.map((ecg) => ({
          ...ecg,
          evidence_columns: [...ecg.evidence_columns.sort((a, b) => {
            let indexA = anotherOrderArray.indexOf(a.evidence_type);
            let indexB = anotherOrderArray.indexOf(b.evidence_type);
            
            // If the evidence_type is not found in anotherOrderArray, send it to the end
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
          })]
        }
      ))
    } else {
        return evidenceColumnGroup.map((ecg) => ({
          ...ecg,
          evidence_columns: [...ecg.evidence_columns.sort((a: EvidenceColumn, b: EvidenceColumn) => 
                                                            (a.evidence_type < b.evidence_type) ? -1 : 1)]
        }
      ))
    }
  }

  render() {
    //const sortingArr = ['Composite','Maze-Adjusted' , 'ORF-Accuracy', 'ORF-WordsCorrect', 'ORF-Errors','WRF',  'NWF-WRC', 'NWF-CLS', 'PSF', 'LNF'];
    
    const {
      evidencePeriodData,
      dataRowHeight,
      groupHeaderHeight,
      headerHeight,
    } = this.state;
    
    const {
      currentDataPeriod,
      hasDiagnosticInfo,
      isLoading,
      isReadonly,
    } = this.props;

    if (isLoading.getEvidenceData && !evidencePeriodData) {
      return <LoadingIndicator />;
    }

    return (
      <div ref={this.refCallback}>
        {evidencePeriodData && (
          <Table
            scrollToRow={this.state.scrollToRow}
            className={`dataTable ${this.props.isCompressedViewOfDataTable || this.props.minimal
              ? "compressed-view"
              : ""
              }`}
            rowHeight={dataRowHeight}
            groupHeaderHeight={groupHeaderHeight}
            headerHeight={headerHeight}
            rowsCount={evidencePeriodData.student_rows?.length}
            width={this.state.tableWidth || 0}
            maxHeight={this.props.isDataInterview ? 600 : (this.state.tableHeight || 1000)}
            onColumnResizeEndCallback={this.onColumnResizeEndCallback}
            //height={screen.height}
          >
            <ColumnGroup
              fixed={true}
              header={this.getStudentColumnGroupHeader()}
            >
              {this.getStudentGroupIconColumn()}
              {this.getStudentCheckColumn()}
              <Column
                allowCellsRecycling
                fixed={true}
                header={
                  <StudentHeaderCell
                    onSort={this.handleSort}
                    sorting={this.state.sorting}
                    isReadonly={this.props.isReadonly}
                  />
                }
                cell={(props) => {
                  const student =
                    evidencePeriodData.student_rows[props.rowIndex].student;
                  const teacherNames = evidencePeriodData.student_rows[
                    props.rowIndex
                  ].student.teachers!.map(
                    (teacher) => `${teacher.first_name} ${teacher.last_name}`
                  );
                  return (
                    <StudentCell
                      key={student.unique_id}
                      isReadonly={this.props.isReadonly}
                      student={student}
                      rowGrade={
                        evidencePeriodData.student_rows[props.rowIndex].grade
                      }
                      draggable={!this.state.isDistrictOwner ? this.checkStudentCellDraggable(student) : false}
                      studentTeacherNames={teacherNames}
                      evidencePeriodData={evidencePeriodData}
                      handleGradeValueChange={this.handleGradeValueChange}
                      onDragStart={this.handleStudentDragStart(student)}
                      onDragEnd={() => this.handleStudentDragEnd(student)}
                      userInfo={this.props.userInfo}
                      showConfirmDialog = {this.props.showConfirmDialog}
                      deleteStudentEntry = {this.props.deleteStudentEntry}
                      userDismissPopupDetails = { this.props.userDismissPopupDetails}
                    />
                  );
                }}
                width={220}
              />
            </ColumnGroup>
            {this.reorderEvidenceColumn(evidencePeriodData.evidence_column_groups)
            .filter((data) => {
              if(typeof(this.props.filterDisplayedGroups) == 'function') {
                if(evidencePeriodData.student_rows?.length) {
                  return this.props.filterDisplayedGroups!(evidencePeriodData.student_rows[0].data_period, data.id)
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .map(
              (evidenceColumnGroup: EvidenceColumnGroup) => (
                <ColumnGroup
                  key={evidenceColumnGroup.id}
                  header={
                    <AssessmentHeaderCell
                      isReadonly={this.props.isReadonly}
                      numberDisplayedColumns={this.getNumberDisplayingColumns(
                        evidenceColumnGroup.id
                      )}
                      evidenceColumnGroup={evidenceColumnGroup}
                      onDisplayedColumnChange={
                        this.handleDisplayedColumnsChange
                      }
                      checkDisplayedColumn={this.isChecked}
                      deleteEvidenceColumnsGroup={
                        this.props.deleteEvidenceColumnsGroup
                      }
                    />
                  }
                >
                  {evidenceColumnGroup.evidence_columns
                    .filter(this.filterDisplayedColumns(evidenceColumnGroup.id))
                    .map((evidenceColumn) => (
                      <Column
                        allowCellsRecycling
                        isResizable={true}
                        minWidth={50}
                        maxWidth={1000}
                        columnKey={this.getColumnKey(
                          evidenceColumnGroup.id,
                          evidenceColumn.id
                        )}
                        key={`${evidenceColumnGroup.id}-${evidenceColumn.id}`}
                        header={
                          <MeasurementHeaderCell
                            sortingDirection={this.checkSorting(
                              evidenceColumnGroup,
                              evidenceColumn
                            )}
                            evidenceColumn={evidenceColumn}
                            evidenceColumnGroup={evidenceColumnGroup}
                            onBenchmarksView={this.handleViewBenchmarks}
                            onEvidenceSort={this.handleDseSort}
                            sorting = {this.state.sorting}
                            isReadonly={this.props.isReadonly}
                          />
                        }
                        cell={(props) => (
                          <DataStudentEntryCell
                            isReadonly={this.props.isReadonly}
                            evidenceColumn={evidenceColumn}
                            dataPeriod={currentDataPeriod}
                            evidenceColumnGroupId={evidenceColumnGroup.id}
                            student={
                              evidencePeriodData.student_rows[props.rowIndex]
                                .student
                            }
                            onCellEditFormChange={this.handleCellEditFormChange}
                            onChangesApply={this.handleChangesApply}
                            onKeyDown={this.handleKeyDown}
                            onSelectedValueChange={
                              this.handleSelectedValueChange
                            }
                            onStudentRowEditingChange={
                              this.handleStudentRowEditingChange
                            }
                            onDiagnosticFollowUpEditingChange={
                              this.handleDiagnosticFollowUpEditingChange
                            }
                            studentEditingRows={this.state.studentEditingRows}
                            evidenceColumnGroup={evidenceColumnGroup}
                            loadingValueOfDSEtoDataPeriod={
                              this.props.isLoading.setValueOfDSEtoDataPeriod
                              || this.props.isLoading.updateValueOfDSEtoDataPeriod
                            }
                          />
                        )}
                        width={this.getColumnWidth(
                          evidenceColumnGroup,
                          evidenceColumn
                        )}
                      />
                    ))}
                </ColumnGroup>
              )
            )}
          </Table>
        )}
        {!isReadonly &&
          evidencePeriodData &&
          !evidencePeriodData.student_rows?.length
          && <EmptyStudentsRows />
        }
        {this.state.selectedEvidence && (
          <ViewBenchmarksModal
            selectedEvidence={this.state.selectedEvidence}
            lowestGradeInData={gradeLevels[(this.lowestGrade && this.lowestGrade != -1) ? this.lowestGrade : 0]}
            onHide={this.handleViewBenchmarksModalHide}
          />
        )}
        <BehaviorScreenerModal />
        <SkillsFocusModal />
        <TeacherInviteIndividuallyModal />
        {/* <RemoveEvidenceConfirmModal /> */}
      </div>
    );
  }

  getShadowImageDiv = () => {
    if (this.shadowImageRef) return this.shadowImageRef;
    const divElement = document.createElement("div");
    const text = document.createTextNode("Add 1 student");
    divElement.className = "ghostImage";
    divElement.appendChild(text);
    this.shadowImageRef = divElement;
    return this.shadowImageRef;
  };
}

export default connectEvidenceTable(EvidenceTable);